<div class="flex bg-surface-100">
  <div
    class="w-[250px] lg:relative fixed left-0 top-0 block z-20 transition-all"
    [ngClass]="isToggled ? 'translate-x-0' : ' translate-x-[-100%] md:translate-x-0'"
  >
    <app-billing-sidebar [user]="user"></app-billing-sidebar>
  </div>
  <div
    class="w-full h-[100vh] overflow-y-auto overflow-x-hidden relative"
  >
    <div
      class="absolute top-0 left-0 w-full"
      [ngClass]="isToggled ? 'activeMobile-header' : ''"
    >
      <app-authenticated-header [user]="user" (toggle)="handleToggle($event)"></app-authenticated-header>
    </div>
    <div class="pt-[76px]"></div>
    <router-outlet></router-outlet>
  </div>
</div>
